module.exports = new __parcel__URL__("Loading.165e6a47.gif").toString();